<template>
    <v-app>
        <summary-core-app-bar v-model="expandOnHover" v-if="get_shared_Path === 'Summary'" />

        <reports-core-drawer :expand-on-hover.sync="expandOnHover" />

        <reports-core-view />

        <reports-core-footer />
    </v-app>
</template>

<script>
	import { mapGetters } from 'vuex';


    export default {
        name: 'ReportsIndex',

        /* >>> *************************************************************** / /* Components */
        components: {

            SummaryCoreAppBar: () => import('./summary/components/core/AppBar'),

            ReportsCoreDrawer: () => import('@/components/core/Drawer'), // global
            ReportsCoreView: () => import('@/components/core/View'), // global
            ReportsCoreFooter: () => import('@/components/core/Footer') // global

        }, // eof components{}
        /* <<< ****************************************************************/


        /* >>> *************************************************************** / /* Data */
        data: () => ({

            expandOnHover: true

        }), // eo function data()
        /* <<< ****************************************************************/


		/* >>> *************************************************************** / /* Computed */
		computed: {

			...mapGetters([
				'get_shared_Path',
			]),

		}, // eo computed{}
		/* <<< ****************************************************************/

    };
</script>
